import { GetListResponse, instance } from "libs/api";

import { ApiRoutesPacks } from "../../constants";
import { PackListItem } from "../../packs.types";
import { GetPacksRequestParams } from "./getPacks.types";

export const requestGetPacks = async (
  params: GetPacksRequestParams
): Promise<GetListResponse<PackListItem>> => {
  return await instance.get(ApiRoutesPacks.AllPacks, { params });
};
